import React from 'react';

import Icon from '@components/icon-component';

import style from './label.module.scss';

const Label = (
  {
    label,
    dot,
    reconciled,
    error,
    className,
    showReconciled = false,
    inLineStyle,
    inlineTextStyle
    // dangerouslySetInnerHTML = false
  },
  ref
) => {
  const dotStyling = dot
    ? `<span style="background-color: #e02b2b; width: 5px; height: 5px; display: inline-block; border-radius: 50%; margin-left: 1px;  margin-bottom: 2px;"></span>`
    : '';

  return (
    <div className={`${style.labelWrapper} ${className}`} style={{ ...inLineStyle }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center'
        }}
        ref={ref}
      >
        <span className={style.labelText} style={{ ...inlineTextStyle }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div
              dangerouslySetInnerHTML={{
                __html: `${label} ${dotStyling}`
              }}
              style={{ display: 'inline' }}
            />
          </div>

          {reconciled && <Icon name={'labelReconciled'} className={style.iconClass} />}
        </span>
      </div>
      {error && (
        <div
          style={{
            overflowWrap: 'break-word'
          }}
        >
          {<span className={style.error}>{error}</span>}
        </div>
      )}
      {!error && showReconciled && (
        <div
          style={{
            overflowWrap: 'break-word'
          }}
        >
          {<span className={style.reconciled}>RECONCILED</span>}
        </div>
      )}
    </div>
  );
};

export default React.forwardRef(Label);
